export const LEAD_QUALITY_VALUES = ["good", "neutral", "bad"];

export const LEAD_QUALITY_OPTIONS = [
  { value: "good", label: "Good" },
  { value: "neutral", label: "Neutral" },
  { value: "bad", label: "Bad" },
];

export function isLeadQuality(value) {
  return LEAD_QUALITY_VALUES.includes(value);
}

export function getLeadQualityLabel(value) {
  if (value === "good") return "Good";
  if (value === "neutral") return "Neutral";
  if (value === "bad") return "Bad";
  return "None";
}

export function getLeadQualityBadgeClass(value) {
  if (value === "good") return "badge-success";
  if (value === "neutral") return "badge-info";
  if (value === "bad") return "badge-danger";
  return "badge-secondary";
}

export function hasAppsFlyerId(user) {
  return Boolean(user?.appsFlyerId || user?.attribution?.appsFlyerId);
}
